import { Modal, Image, Typography } from "antd";
import "./style.css";
import Done from "../../assets/done.png";

const Modals = ({
  open,
  handleOk,
  handleCancel,
  text,
  footer,
  okText,
  cancelText,
  title,
}) => {
  return (
    <div>
      <Modal
        centered
        open={open}
        onOk={() => handleOk()}
        onCancel={() => handleCancel()}
        footer={footer}
        okText={okText}
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText={cancelText}
        cancelButtonProps={{
          className: "web-btn2",
        }}
        okButtonProps={{
          className: "web-btn2",
        }}
      >
        <Image src={Done} preview={false} width={80} height={80} />
        <h5
          style={{
            fontSize: "24px",
            fontFamily: "WAGHU Personal Use",
            padding: "10px",
            fontWeight: 600,
          }}
        >
          {title}
        </h5>
        <Typography.Title
          level={2}
          style={{
            fontSize: "16px",
            fontFamily: "Poppins', sans-serif",
            padding: "10px",
            fontWeight: 500,
          }}
        >
          {text}
        </Typography.Title>
      </Modal>
    </div>
  );
};

export default Modals;
